export default __webpack_public_path__ + "static/heartfulness-logo-5f8a554350b2b93a3bddadcd7937db47.svg";